import { Box, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import { MainLoader } from '../../../shared/components/MainLoader';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyItems: 'center',
      placeItems: 'center',
      position: 'relative',
    },
    forceCentering: {
      margin: 'auto auto',
    },
    loadingGiftContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
      placeItems: 'center',
      textAlign: 'center',
      paddingBottom: '20px',
      position: 'relative',
    },
  }),
);
type PlanLoadingProps = {
  containerClassName?: string;
};
export const PaymentMethodLoader: React.FC<PlanLoadingProps> = ({
  containerClassName,
}) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={containerClassName ? containerClassName : classes.container}
      >
        <Box className={classes.forceCentering}>
          <div className={classes.loadingGiftContainer}>
            <MainLoader height="250px">Cargando...</MainLoader>
          </div>
        </Box>
      </div>
    </>
  );
};
